<template>
  <Main />
</template>

<script>
import Main from "../../components/Main/Main.vue";

export default {
  name: "app",
  components: {
    Main
  }
};
</script>
